import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { FC, useEffect, useRef, useState } from "react";

import { useT } from "src/internationalization";

const StreetView: FC<{ center: { lat: number; lng: number } }> = ({ center }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isStreetViewAvailable, setIsStreetViewAvailable] = useState(false);
  const streetViewLibrary = useMapsLibrary("streetView");
  const t = useT();

  useEffect(() => {
    if (!window.google?.maps || !streetViewLibrary) return;

    const streetViewService = new streetViewLibrary.StreetViewService();
    const radius = 50; // meters

    streetViewService.getPanorama({ location: center, radius }, (results, status) => {
      if (status === "OK" && results?.location) {
        setIsStreetViewAvailable(true);
        new window.google.maps.StreetViewPanorama(containerRef.current!, {
          position: center,
          pov: { heading: 0, pitch: 0 },
          zoom: 1,
        });
      } else {
        setIsStreetViewAvailable(false);
      }
    });
  }, [center, streetViewLibrary]);

  return isStreetViewAvailable ? (
    <div ref={containerRef} className={"w-full h-full"} />
  ) : (
    <div className={"p-4 text-center text-textError"}>{t("widget.googleMap.streetView.error")}</div>
  );
};

export default StreetView;
